import axios from "axios";
import { getHeaders } from "services/AuthHeader";
import { ResponseError } from "types/responses/ResponseError";

const API_URL = process.env.REACT_APP_API_URL;

export async function ForgottenPassowrdService(email: string, language: any) {
    try {
        const response = await axios.post(
            API_URL + '/forgotten_password',
            {
                email: email,
                language: language,
                return_url: window.location.href   
            }, {
                headers: getHeaders()
            }
        )
        
        if ("error" in response.data) {
            return response.data.error
        }
        if ("user" in response.data) {
            return response.data.user            
        }

        return "general_error"

    } catch (error) {
        return ResponseError.general_error
    }
}